import React from "react";

import { shallow } from "zustand/shallow";

import CollapsibleSidebar from "@app/analytics/components/reports/CollapsibleSidebar";
import { SidebarContentOuterContainer } from "@app/analytics/components/reports/styles";
import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";

import TopicReportSidebarContent from "./TopicReportSidebarContent";

const TopicReportSidebar = () => {
  const [sidebarExpanded, setSidebarExpanded] = useTopicReportStore(
    (state) => [state.sidebarExpanded, state.setSidebarExpanded],
    shallow
  );

  // Override the content padding for all screen sizes to allow for the whole box
  // shadow to show when an entity is selected; the inner components will handle
  // spacing themselves from the edges accordingly
  return (
    <CollapsibleSidebar
      expanded={sidebarExpanded}
      onToggleExpand={setSidebarExpanded}
      sx={{
        padding: "0 !important",
        minWidth: { mobile: "300px", lg: "400px", xl: "500px" },
        maxWidth: { mobile: "300px", lg: "400px", xl: "500px" },
      }}
      backgroundColor="#FFF"
    >
      <SidebarContentOuterContainer>
        <TopicReportSidebarContent />
      </SidebarContentOuterContainer>
    </CollapsibleSidebar>
  );
};

export default TopicReportSidebar;
